import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface HelpSectionState {
  display: boolean;
  module: string;
}

const initialPortalDashboardDataState: any = {
  isModalVisible: false,
  title: "",
  component: null,
};

const portalDashboardDataSlice = createSlice({
  name: "portalDashboardData",
  initialState: initialPortalDashboardDataState,
  reducers: {
    setPortalData: (_state: any, action: any) => action.payload,
    setModalVisiblity: (state: any, action: any) => ({ ...state, ...action.payload }),
  },
});

const helpSectionStateSlice = createSlice({
  name: "helpSectionState",
  initialState: { display: false, module: "general" },
  reducers: {
    setHelpSectionState: (_state: any, action: PayloadAction<HelpSectionState>) => action.payload,
  },
});

const reducerHeaderSlice = createSlice({
  name: "reducerHeader",
  initialState: true,
  reducers: {
    setReduceHeader: (_state: any, action: PayloadAction<boolean>) => action.payload,
  },
});

const portalDashboardObjectSlice = createSlice({
  name: "portalDashboardObject",
  initialState: {},
  reducers: {
    setPortalDashboardObject: (_state: any, action: any) => action.payload,
  },
});

export const { setPortalData, setModalVisiblity } = portalDashboardDataSlice.actions;
export const { setPortalDashboardObject } = portalDashboardObjectSlice.actions;
export const { setHelpSectionState } = helpSectionStateSlice.actions;
export const { setReduceHeader } = reducerHeaderSlice.actions;

export const portalDashboardData = portalDashboardDataSlice.reducer;
export const helpSectionState = helpSectionStateSlice.reducer;
export const onReduceHeader = reducerHeaderSlice.reducer;
export const portalDashboardObject = portalDashboardObjectSlice.reducer;

export default portalDashboardDataSlice.reducer;
